// extracted by mini-css-extract-plugin
module.exports =  {"light-close-button":"h3HYQXE","lightCloseButton":"h3HYQXE"};